import {
  Box,
  Button,
  IconButton,
  Link,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import {
  getGradingData,
  GradingSubComponent,
  postComponentdataDetails,
} from '../../../../../Utils/apiServices';
import KenCard from '../../../../../global_components/KenCard';
import KenGridEditable from '../../../../../global_components/kenEditDataGrid/KenGridEcditableForStudentStatus';
import EditIcon from '@material-ui/icons/Edit';
import DoneIcon from '@material-ui/icons/Done';
import CloseIcon from '@material-ui/icons/Close';
import RevertIcon from '@material-ui/icons/NotInterestedOutlined';
import { useLocation } from 'react-router-dom';
import KenLoader from '../../../../../Components/KenLoader';

const useStyles = makeStyles((theme) => ({}));
const StudentSubComponetsDetails = () => {
  const classes = useStyles();
  const idUseLocaction = useLocation();
  const [rows, setRows] = useState([]);

  const [previous, setPrevious] = useState({});
  const [loading, setLoading] = React.useState(false);
  const onToggleEditMode = (check, id, index) => {
    const newData = [...rows];
    setRows((state) => {
      return newData.map((row) => {
        if (row.id === id) {
          if (check === 'done') {
            row.isEditMode = true;

            console.log('rowrowrowrowrowrowrowrow', row);
            const payload = [
              {
                Subid: row.id,
                SubMarksobtained: row.marks_obtain,
                SubTotalMarks: row.total_marks,
              },
            ];
            postComponentdataDetails(
              idUseLocaction.pathname.split('/')[7],
              payload
            )
              .then(() => {
                getSubComponentData();
              })
              .catch((err) => {
                console.log('errFromSub', err);
              });
            return { ...row, isEditMode: !row.isEditMode };
          }
          if (check === 'edit') {
            return { ...row, isEditMode: !row.isEditMode };
          }
        }
        return row;
      });
    });
  };

  const onChange = (e, row) => {
    console.log('erow', e, row);
    if (!previous[row.id]) {
      setPrevious((state) => ({ ...state, [row.id]: row }));
    }
    const value = e.target.value;
    const name = e.target.name;
    const { id } = row;
    const newRows = rows.map((row) => {
      if (row.id === id) {
        return { ...row, [name]: value };
      }
      return row;
    });
    setRows(newRows);
  };

  const onToggleEdit = (id, rowes) => {
    setRows((state) => {
      return rowes.map((row) => {
        if (row.id === id) {
          return { ...row, isEditMode: !row.isEditMode };
        }
        return row;
      });
    });
  };
  const onRevert = (id) => {
    const newRows = rows.map((row) => {
      if (row.id === id) {
        return previous[id] ? previous[id] : row;
      }
      return row;
    });
    setRows(newRows);
    setPrevious((state) => {
      delete state[id];
      return state;
    });
    onToggleEdit(id, newRows);
  };
  const getSubComponentData = () => {
    setLoading(true);

    getGradingData(idUseLocaction.pathname.split('/')[7]).then((res) => {
      setLoading(true);

      const data =
        res === null
          ? []
          : res?.map((item) => {
              setLoading(true);
              if (
                item.courseOfferingId ===
                  idUseLocaction.pathname.split('/')[5] &&
                item.studentId === idUseLocaction.pathname.split('/')[7] &&
                item.ComponentName === idUseLocaction.pathname.split('/')[8]
              ) {
                // console.log("id.pathname.split('/')[5]", item);
                const subComponentDetails = item.Subcomponent.map((data) => {
                  setLoading(true);

                  return {
                    id: data.Subid,
                    component_name: data.SubComponentName,
                    // id: item.facultyId,
                    marks_obtain: data.Marksobtained,
                    total_marks: data.SubTotalMarks,
                  };
                  setLoading(false);

                  // setLoading(true);
                });

                setRows(subComponentDetails);
                setLoading(false);
              }
            });
      setLoading(false);
    });
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);

    getSubComponentData();
    setLoading(false);
  }, []);
  console.log('datadadtadtdadtadta', rows);
  return (
    <div>
      {' '}
      <Box className={`cardlsitbox`}>
        {loading && <KenLoader />}
        <KenCard elevation={0}>
          <Typography variant="h5">Sub Components</Typography>

          <Table aria-label="caption table">
            <TableHead>
              <TableRow>
                <TableCell className="tableHeaderTitle" align="left">
                  Sub Component Name
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  Marks Obtain
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  Total Marks
                </TableCell>

                <TableCell className="tableHeaderTitle" align="left">
                  Edit
                </TableCell>
                <TableCell
                  className="tableHeaderTitle"
                  align="center"
                ></TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="tablebody1">
              {rows.length === 0 && (
                <TableCell colSpan={8}>No Record</TableCell>
              )}
              {rows.map((row) => {
                const SetDateFormat = {
                  ...row,
                };
                {
                  console.log('rowrowrowrowrow111111111', row);
                }
                return (
                  <TableRow className="editableTableRowData" key={row.id}>
                    <>
                      {/* <TableCell>
                        <Button>
                          <Link
                            // className={classes.profile}
                            // onClick={() => onProfileView()}
                            style={{ fontSize: '10px' }}
                            to={{
                              pathname: `${routes.grading}/details/${row?.courseOfferingId}/studentdetails/${row?.id}/${row.component_name}`,
                            }}
                          >
                            {row.component_name}
                          </Link>
                        </Button>
                      </TableCell> */}
                      <KenGridEditable
                        {...{
                          row: SetDateFormat,
                          onChange,
                          columns: [
                            // {
                            //   column_name: 'studentName',
                            //   is_inline_edit: false,
                            //   inline_edit_type: '',
                            //   label: 'StudentList',
                            // },

                            {
                              column_name: 'component_name',
                              is_inline_edit: true,
                              inline_edit_type: 'kenInput',
                              label: 'component_name',
                            },
                            {
                              column_name: 'marks_obtain',
                              is_inline_edit: true,
                              inline_edit_type: 'kenInput',
                              label: 'marks_obtain',
                            },
                            {
                              column_name: 'total_marks',
                              is_inline_edit: true,
                              inline_edit_type: 'kenInput',
                              label: 'total_marks',
                            },
                          ],
                        }}
                      />
                      <TableCell className={classes.selectTableCell}>
                        {row.isEditMode ? (
                          <>
                            <IconButton
                              aria-label="done"
                              onClick={() => onToggleEditMode('done', row.id)}
                            >
                              <DoneIcon />
                            </IconButton>
                            <IconButton
                              aria-label="revert"
                              onClick={() => onRevert(row.id)}
                            >
                              <RevertIcon />
                            </IconButton>
                          </>
                        ) : (
                          <IconButton
                            aria-label="delete"
                            onClick={() => onToggleEditMode('edit', row.id)}
                          >
                            <EditIcon />
                          </IconButton>
                        )}
                      </TableCell>

                      {/* {row.status === 'Under process' ? (
                      <TableCell className={classes.selectTableCell}>
                        <Box>
                          <div style={{ display: 'flex' }}>
                            <Button
                              variant="primary"
                              component={Link}
                              className={classes.error}
                              // to={`${routes.invigilationProctoring}/${id}`}
                            >
                              Under process
                            </Button>
                          </div>
                        </Box>
                      </TableCell>
                    ) : (
                      <TableCell className={classes.selectTableCell}>
                        <Box>
                          <div style={{ display: 'flex' }}>
                            <Button
                              variant="primary"
                              component={Link}
                              className={classes.normal}
                              // to={`${routes.seatingPlan}/arrangement/${id}`}
                            >
                              Completed
                            </Button>
                          </div>
                        </Box>
                      </TableCell>
                    )} */}

                      {/* <TableCell className={classes.selectTableCell}>
                          {row.isEditMode ? (
                            <>
                              <IconButton
                                aria-label="done"
                                onClick={() => onToggleEditMode('done', row.id)}
                              >
                                <DoneIcon />
                              </IconButton>
                              <IconButton
                                aria-label="revert"
                                onClick={() => onRevert(row.id)}
                              >
                                <RevertIcon />
                              </IconButton>
                            </>
                          ) : (
                            <IconButton
                              aria-label="delete"
                              onClick={() => onToggleEditMode('edit', row.id)}
                            >
                              <EditIcon />
                            </IconButton>
                          )}
                        </TableCell> */}
                      {/* </TableRow> */}
                    </>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </KenCard>
      </Box>
    </div>
  );
};

export default StudentSubComponetsDetails;
